import { GetterApiEndpointNames } from 'new-components/DLS/OpDataFetchTable/types';

export const intensiveApiEndpointNames: GetterApiEndpointNames[] = [
  'listUsers',
];
